import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSchool } from 'features/schools/hooks/useSchools';
import { isSchoolActive } from 'features/schools/utils/schoolVisibility';
import { PageSkeleton } from 'components/ui/Skeleton';
import { ROUTES } from 'constants/routes';

interface SchoolActiveGuardProps {
  slug: string;
  children: React.ReactNode;
}

export function SchoolActiveGuard({ slug, children }: SchoolActiveGuardProps) {
  const navigate = useNavigate();
  const { data: school, isLoading } = useSchool(slug);

  useEffect(() => {
    if (!isLoading && school && !isSchoolActive(school)) {
      navigate(ROUTES.DASHBOARD, { replace: true });
    }
  }, [school, isLoading, navigate]);

  if (isLoading) return <PageSkeleton />;
  if (!school || !isSchoolActive(school)) return null;

  return <>{children}</>;
}
